import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { BuilderStatus, type Maybe } from '@/modules/__generated__/graphql/switchboard-generated';
import { GenericChip } from '../generic-chip/generic-chip';
interface BuildersStatusChipProps {
  status: Maybe<BuilderStatus> | undefined;
}
function BuildersStatusChip(t0) {
  const $ = _c(9);
  const {
    status
  } = t0;
  let t1;
  bb0: {
    if (!status) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          label: "Unknown",
          color: "gray"
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    switch (status) {
      case BuilderStatus.Active:
        {
          let t2;
          if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Active",
              color: "blue"
            };
            $[1] = t2;
          } else {
            t2 = $[1];
          }
          t1 = t2;
          break bb0;
        }
      case BuilderStatus.Inactive:
        {
          let t2;
          if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Inactive",
              color: "gray"
            };
            $[2] = t2;
          } else {
            t2 = $[2];
          }
          t1 = t2;
          break bb0;
        }
      case BuilderStatus.OnHold:
        {
          let t2;
          if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "On Hold",
              color: "orange"
            };
            $[3] = t2;
          } else {
            t2 = $[3];
          }
          t1 = t2;
          break bb0;
        }
      case BuilderStatus.Completed:
        {
          let t2;
          if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Completed",
              color: "green"
            };
            $[4] = t2;
          } else {
            t2 = $[4];
          }
          t1 = t2;
          break bb0;
        }
      case BuilderStatus.Archived:
        {
          let t2;
          if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Archived",
              color: "gray"
            };
            $[5] = t2;
          } else {
            t2 = $[5];
          }
          t1 = t2;
          break bb0;
        }
    }
    t1 = undefined;
  }
  const {
    label,
    color
  } = t1;
  let t2;
  if ($[6] !== color || $[7] !== label) {
    t2 = <GenericChip variant="filled" color={color}>{label}</GenericChip>;
    $[6] = color;
    $[7] = label;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export { BuildersStatusChip };